import { finalize, tap } from 'rxjs/operators';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  FormControl,
  FormGroup,
  NonNullableFormBuilder,
  Validators,
} from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslationService } from '@proximus/ng-common';
import { Line } from '../models/line.model';
import { Ont } from '../models/ont.model';
import { ModemChoiceService } from '../modem-choice.service';

@UntilDestroy()
@Component({
  selector: 'mprd-modem-choice-edit-ont',
  templateUrl: './modem-choice-edit-ont.component.html',
})
export class ModemChoiceEditOntComponent {
  @Input() line!: Line;
  @Input() ncName!: string;
  @Input() open = false;
  @Output() openChange = new EventEmitter<boolean>();
  @Output() edited = new EventEmitter<Ont>();
  pending = false;
  form: FormGroup<{ serialNumber: FormControl<string> }>;

  constructor(
    private fb: NonNullableFormBuilder,
    private translationService: TranslationService,
    private modemChoiceService: ModemChoiceService,
  ) {
    const serialNumberValidator = Validators.pattern(
      this.translationService.getTranslatedValueFor(
        'modem-choice.ont-serial-number-regex',
      ) as string,
    );
    this.form = this.fb.group({
      serialNumber: ['', [Validators.required, serialNumberValidator]],
    });
  }

  onEdit(): void {
    const serialNumber = this.serialNumber.value.toUpperCase();
    this.pending = true;
    this.modemChoiceService
      .updateOnt(this.line.circuitId, this.ncName, { serialNumber })
      .pipe(
        tap(() => {
          this.edited.emit({
            ...this.line.devices.find(
              (device) => device.ncName === this.ncName,
            ),
            serialNumber,
          });
          this.close();
        }),
        finalize(() => (this.pending = false)),
        untilDestroyed(this),
      )
      .subscribe();
  }

  onClose(): void {
    if (this.pending) return;
    this.close();
  }

  private close(): void {
    this.open = false;
    this.openChange.emit(false);
  }

  get serialNumber(): FormControl<string> {
    return this.form.controls.serialNumber;
  }
}
